<template>

	<div 
		:class="{'number-total':true,'top-border':borderColour!=='', 'has-shadow': shadow, labelLeft: labelAlign==='left', labelRight: labelAlign==='right'}" 
		:style="styles['number-total']"
	>

		<div :class="{ 'label-wrap': true, 'has-tip': tip !== '', top: labelAlign==='top', left: labelAlign==='left', 'has-label2': label2!=='' }" v-if="label!=='' && ( labelAlign==='top' || labelAlign==='left' )">

			<h3 
				:class="{'number-total-label':true}" 
				:style="[styles['number-total-label']]"
				v-html="label"
			/><h4 
				:class="{'number-total-label2':true}" 
				:style="[styles['number-total-label2']]"
				v-html="label2" 
				v-if="label2!==''" 
			/>

			<Tip v-if="tip" :styles="{ 'font-size': '12px' }" position="fromCentre"><span>{{ tip }}</span></Tip>

		</div><h2 
			class="number-total-value" 
			:style="[styles['number-total-value'],fontSize(theTotal)]"
		><span class="circle" :style="[styles['number-total-value-circle']]">{{ theTotal }}</span><span v-if="history && typeof history.hide === 'undefined'" :class="{ history: true, red: history.colour === 'red', orange: history.colour === 'orange', green: history.colour === 'green' }">{{ history.symbol }}{{ formatNumber(history.value) }}</span></h2><div :class="{ 'label-wrap': true, bottom: labelAlign==='bottom', 'has-tip': tip !== '', right: labelAlign==='right', 'has-label2': label2!=='' }" v-if="label!=='' && ( labelAlign==='bottom' || labelAlign==='right' )">

			<h3 
				:class="{'number-total-label':true}" 
				:style="[styles['number-total-label']]" 
				v-html="label"
			/><h4 
				:class="{'number-total-label2':true}" 
				:style="[styles['number-total-label2']]"
				v-html="label2" 
				v-if="label2!==''" 
			/>

			<Tip v-if="tip!==''" :styles="{ 'font-size': '12px' }" position="fromCentre"><span>{{ tip }}</span></Tip>

		</div>

	</div>

</template>

<script>
import { computed } from 'vue';
import Tip from './../Tip.vue'
export default {
	name: 'NumberTotal',
	components: { Tip },
	props: {
		clickable: {
			type: Boolean,
			default: false
		},
		total: {
			type: [Number,String],
			default: 1
		},
		totalColour: {
			type: String,
			default: '#000'
		},
		ringColour: {
			type: String,
			default: ''
		},
		ringFill: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		labelColour: {
			type: String,
			default: '#000'
		},
		label2: {
			type: String,
			default: ''
		},
		label2Colour: {
			type: String,
			default: '#000'
		},
		labelAlign: {
			type: String,
			default: 'bottom',
			validator: function (value) {
				return ['top', 'bottom', 'left', 'right'].indexOf(value) !== -1
			}
		},
		borderColour: {
			type: String,
			default: ''
		},
		bg: {
			type: String,
			default: '#fff'
		},
		shadow: {
			type: Boolean,
			default: false
		},
		history: {
			type: Object,
			default: function () { return { hide: true } }
		},
		tip: {
			type: String,
			default: ''
		}
	},
	setup(props) {
		const formatNumber = (n) => {
			if (n === null || n === undefined) return '';
			let am = 'K', tot = parseFloat((n.toString()).replace(',', ''));

			if (tot >= 1000000) {
				am = 'M';
				tot /= 1000000; // Corrected from 1000 to 1,000,000
				return tot.toFixed(1) + am;
			}
			else if (tot >= 1000) {
				tot /= 1000;
				if (parseFloat(tot.toFixed(0)) < parseFloat(tot.toFixed(1))) {
					tot = tot.toFixed(1);
				} else {
					tot = tot.toFixed(0);
				}
				return tot + am;
			}
			else {
				if ((n.toString()).length > 5) {
					tot = tot.toFixed(2);
				}
			}
			return tot;
		};

		const theTotal = computed(() => {
			return formatNumber(props.total);
		});

		const styles = computed(() => {
			const styles = {};
			const styleOps = {
				'number-total': {
					bg: 'background-color',
					borderColour: 'border-color'
				},
				'number-total-value': {
					totalColour: 'color'
				},
				'number-total-label': {
					labelColour: 'color'
				},
				'number-total-label2': {
					label2Colour: 'color'
				},
				'number-total-value-circle': {
					ringColour: 'border-color',
					ringFill: 'background-color'
				}
			};

			Object.keys(styleOps).forEach(selector => {
				if (typeof styles[selector] === 'undefined') {
					styles[selector] = {};
				}
				Object.keys(styleOps[selector]).forEach(item => {
					if (typeof props[item] !== 'undefined') {
						styles[selector][styleOps[selector][item]] = props[item];
					}
				});
			});

			return styles;
		});

		const fontSize = (label) => {
			let fs = { fontSize: '100%' };
			const l = label.toString();

			if (l.length > 2) fs.fontSize = '80%';
			if (l.length > 3) fs.fontSize = '70%';
			if (l.length > 4) fs.fontSize = '60%';
			if (l.length > 5) fs.fontSize = '50%';
			if (l.length > 6) fs.fontSize = '42%';
			if (l.length > 7) fs.fontSize = '38%';
			if (l.length > 8) fs.fontSize = '35%';
			if (l.length > 9) fs.fontSize = '31%';

			return fs;
		};

		return {
			theTotal,
			styles,
			fontSize,
			formatNumber
		};
	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
	
	.number-total {

		padding: 20px;
		box-sizing: border-box;
		vertical-align: top;
		font-size: 40px;
		width: 140px;
			
		&.top-border {

			border-top:5px solid red;

		}

		&.has-shadow {

			-webkit-box-shadow: 5px 5px 15px -6px rgba(0, 0, 0, 0.2);
			-moz-box-shadow: 5px 5px 15px -6px rgba(0, 0, 0, 0.2);
			box-shadow: 5px 5px 15px -6px rgba(0, 0, 0, 0.2);

		}

		.number-total-value, .number-total-label, .number-total-label2 {

			color: #fff;
			padding:0;
			margin:0;
			line-height: 1em;
			font-size:100%;
			text-align:inherit;

		}

		.number-total-value {

			justify-content: center;
			align-items: center;
			border-radius: 100%;
			text-align: center;
			display: inline-flex;
			border:2px solid @darkContrast;
			width: 94px;
			height: 94px;
			position:relative;

			.circle {

				border:4px solid @formDefaultColour;
				width: 86px;
			    height: 86px;
				display: block;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				display: inline-flex;

			}

			.history {

				font-size: 13px;
				padding:0;
				display: block;
			    position: absolute;
			    line-height: 1em;
			    bottom: 12px;

				&.red {
					color: @red;
				}
				&.orange {
					color: @orange;
				}
				&.green {
					color: @green;
				}

			}

		}

		.number-total-label, .number-total-label2 {

			font-size:12px;
			color: rgba(0,0,0,0.7);

		}

		.label-wrap {

			vertical-align: top;
			text-align: center;
			position: relative;

			&.has-tip {

				position: relative;
				padding-bottom: 25px;

				.tip {

					position: absolute;
					left: 50%;
					bottom: 0;
					margin-left: -11px;

					.tip-label {

						font-size: 12px;

					}

				}

			}

			&.top {

				margin-bottom: 12px;

			}

			&.bottom {

				margin-top: 12px;

			}

		}	

		&.labelLeft, &.labelRight {

			-webkit-transform-style: preserve-3d;
			-moz-transform-style: preserve-3d;
			transform-style: preserve-3d;
			position: relative;
			padding-top:0;
			padding-bottom:0;

			.label-wrap, .number-total-value {

				width: 50%;
				display: inline-block;

			}

			.number-total-value {

				margin-top:20px;
				margin-bottom:20px;

			}

			.label-wrap {

				position: absolute;
				top: 50%;
				-webkit-transform: translateY(-50%);
				-ms-transform: translateY(-50%);
				transform: translateY(-50%);
				-ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=1, M12=0, M21=0, M22=1, SizingMethod='auto expand')";

				&.has-label2 {

					.number-total-label {

						margin-bottom: 5px;

					}

				}

			}
			
		}

		&.labelLeft {

			.label-wrap {

				text-align: left;
				left:20px;

			}

			.number-total-value {

				text-align: right;
				margin-left: 50%;

			}

		}

		&.labelRight {

			.label-wrap {

				text-align: right;
				right:20px;

			}

			.number-total-value {

				text-align: left;

			}

		}

	}

	@media screen and (min-width: 440px) {

		.number-total {

			margin:0 0 1% 0;

		}

	}

</style>